<template>
    <vs-tabs>
        <vs-tab label="발매신청 관리">
            <applicationComponent></applicationComponent>
        </vs-tab>
        <vs-tab label="캘린더">
            <calendarComponent></calendarComponent>
        </vs-tab>
    </vs-tabs>
</template>

<script>
import { format, parseISO, startOfMonth, isEqual } from 'date-fns'
import swal from 'sweetalert2'
import applicationComponent from'./apply.vue' 
import calendarComponent from'./index_copy.vue' 
  
import Vue from 'vue'
 
 


export default {
  components: {
    applicationComponent,
    calendarComponent
  },
  
  data () {
    return {
       
    }
  },
  beforeMount () {
    
    
  },
  mounted(){
    this.$nextTick(()=>{
    
    })
  },
  methods: {
    
  },
  watch: {
    
    
  },
}
</script>
